import TextAreaField from '../../../Core/widget/TextAreaField.js';
import FormTab from '../../../SchedulerPro/widget/taskeditor/FormTab.js';

/**
 * @module Gantt/widget/projecteditor/ProjectEditorDescriptionTab
 */

/**
 * A tab inside the {@link Gantt/widget/ProjectEditor project editor} showing the description for a project.
 *
 * | Field ref          | Type                              | Weight | Description                                                                                     |
 * |--------------------|-----------------------------------|--------|-------------------------------------------------------------------------------------------------|
 * | `descriptionField` | {@link Core/widget/TextAreaField} | 100    | Shows a text field widget with a textarea as input element, to add a description to the project |
 *
 * @extends  SchedulerPro/widget/taskeditor/FormTab
 * @classtype ProjectEditorDescriptionTab
 */
export default class ProjectEditorDescriptionTab extends FormTab {

    static $name = 'ProjectEditorDescriptionTab';

    static type = 'projecteditordescriptiontab';

    static configurable = {
        title : 'L{description}',

        layoutStyle : {
            alignContent : 'stretch'
        },
        items : {
            descriptionField : {
                weight : 100,
                type   : TextAreaField.type,
                name   : 'description'
            }
        }
    };
}

// Register this widget type with its Factory
ProjectEditorDescriptionTab.initClass();
